<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<mat-extended-select
	[placeholder]="placeholder"
	[required]="false"
	[option$]="roleList$"
	[includeFilter]="true"
	[multiSelect]="false"
	[formControl]="internalField"
	[sortOptions]="true"
	[labelPath]="['view', 'roleName']"
	[valuePath]="['$id']"
	[includeNotSetOption]="allowNullSelection"
	[isNotSetValid]="allowNullSelection"
	[notSetLabel]="notSetLabel"
	[iconBackgroundColorPath]="['view', 'color']"
	subScriptSizing="dynamic"
>
</mat-extended-select>
